<div container>
  <div class="form mx-auto">
    <p>Required<span class="text-danger">*</span></p>

    <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
      <div class="form__fields d-grid mb-3">
        @for (control of formControls; track $index) {
        <ng-container [ngSwitch]="control.type">
          <!-- Insert <hr> only above the 'terms' control -->
          <hr class="mt-1" *ngIf="control.id === 'terms'" />
          <div [class]="control.hiddenClass" *ngIf="control.type == 'radio' && control.id == 'screening'">
            <div class="radio__options d-block mt-0">
              <label [for]="control.id" class="label mb-2" *ngIf="control.label || control.checkboxText"><span
                  [innerHTML]="sanitizeHTML(control.label)" *ngIf="control.label"></span>
                <span [innerHTML]="sanitizeHTML(control.checkboxText)" *ngIf="control.checkboxText"
                  (click)="onCheckboxTextClick($event)"></span>
                <span class="text-danger" *ngIf="control.isRequired">*</span></label>
              <div class="radio__wrapper" (change)="onRadioCheck($event)" *ngSwitchCase="'radio'">
                <div class="radio__box">
                  @for (radio of control.radioOptions; track $index) {
                  <div class="radio__layout d-flex ps-0">
                    <div class="custom-input-container d-flex">
                      <input class="" type="radio" [name]="control.id!" [id]="control.id + '-' + radio.label"
                        [name]="control.id" [formControlName]="control.id!" [value]="radio.option" />
                      <div class="custom__input-radio"></div>
                    </div>
                    <label [for]="control.id + '-' + radio.label" class="form-check-label cursor-pointer">
                      {{ radio.label }}
                    </label>
                  </div>
                  } @if (control.isRequired && form.get(control.id)?.invalid &&
                  form.get(control.id)?.touched) {
                  <p [id]="control.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
                    {{ control.errorMessage }}
                  </p>
                  }
                </div>
              </div>
            </div>
            @if (control.radioNoOptions) {
            <div class="radio__no-options pb-3 radio__no-options--hide">
              <label class="radio__no-options__label mb-3">
                <span [innerHTML]="control.radioNoOptionsLabel || ''"></span><span class="text-danger"
                  *ngIf="control.isRequired">*</span>
                <br />
                <!-- <span>Please select one *</span> -->
              </label>
              <div class="radio__no-options__options d-flex flex-column gap-3">
                @for (noRadio of noRadioOptionsList; track $index) {
                <div class="form-check d-flex align-items-center gap-3">
                  <input class="form-check-input mt-0" type="checkbox" [id]="noRadio.value" [name]="noRadio.value"
                    [value]="noRadio.value"
                    [checked]="(form.get('noradioscreening')?.value ?? []).includes(noRadio.value || '')"
                    [disabled]="isNoRadioDisabled(noRadio.value || '')" (change)="onNoRadioCheck($event, noRadio)" />
                  <label [for]="noRadio.value" class="form-check-label">
                    {{ noRadio.label }}
                  </label>
                </div>
                }
              </div>
              @if (form.get('noradio' + control.id)?.invalid &&
              form.get('noradio' + control.id)?.touched) {
              <p [id]="'noradio' + control.id + 'HelpBlock'" class="text-danger mt-3 mb-0">
                {{ control.radioNoOptionsErrorMsg }}
              </p>
              }
            </div>
            }
          </div>

          <div [class]="control.hiddenClass" *ngIf="control.type == 'radio' && control.id == 'contactpreference'">
            <div class="radio__options d-block mt-0">
              <label [for]="control.id" class="label mb-2" *ngIf="control.label || control.checkboxText"><span
                  [innerHTML]="sanitizeHTML(control.label)" *ngIf="control.label"></span>
                <span [innerHTML]="sanitizeHTML(control.checkboxText)" *ngIf="control.checkboxText"
                  (click)="onCheckboxTextClick($event)"></span>
                <span class="text-danger" *ngIf="control.isRequired">*</span></label>
              <div class="radio__wrapper" (change)="onRadioCheck($event)" *ngSwitchCase="'radio'">
                <div class="radio__box">
                  @for (radio of control.radioOptions; track $index) {
                  <div class="radio__layout d-flex ps-0">
                    <div class="custom-input-container d-flex">
                      <input class="" type="radio" [name]="control.id!" [id]="control.id + '-' + radio.label"
                        [name]="control.id" [formControlName]="control.id!" [value]="radio.option" />
                      <div class="custom__input-radio"></div>
                    </div>
                    <label [for]="control.id + '-' + radio" class="form-check-label cursor-pointer">
                      {{ radio.label }}
                    </label>
                  </div>
                  } @if (control.isRequired && form.get(control.id)?.invalid &&
                  form.get(control.id)?.touched) {
                  <p [id]="control.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
                    {{ control.errorMessage }}
                  </p>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- other form controls -->
          <div *ngIf="control.id == 'receiveDirect'">
            <div class="border-box">
              <div class="form-check">
                <input class="form-check-input mt-0" type="checkbox" [id]="control.id" [name]="control.id"
                  [formControlName]="control.id" />
                <label class="form-check-label body-3 pt-1" [for]="control.id">
                  <span [innerHTML]="sanitizeHTML(control.checkboxText)" *ngIf="control.checkboxText"
                    (click)="onCheckboxTextClick($event)"></span>
                  <span class="text-danger" *ngIf="control.isRequired">*</span>
                </label>
              </div>
              <!-- fields for direct mail checkbox -->
              <ng-container *ngFor="let addrControl of formControls" [ngSwitch]="addrControl.id">
                <ng-container *ngSwitchCase="'addressOne'">
                  <hr class="middle-control middle-control--hide" />
                  <div [class]="addrControl.hiddenClass + ' mt-3'">
                    <label [for]="addrControl.id" class="label mb-2" *ngIf="addrControl.label"><span
                        [innerHTML]="sanitizeHTML(addrControl.label)"></span><span class="text-danger"
                        *ngIf="addrControl.isRequired">*</span></label>
                    <input type="text" [id]="addrControl.id" [placeholder]="addrControl.placeholder ?? ''"
                      class="form-control body-2" [attr.aria-describedby]="addrControl.id + 'HelpBlock'"
                      [attr.maxLength]="addrControl.maxLength!" [name]="addrControl.id"
                      [formControlName]="addrControl.id" [mask]="addrControl.mask!" />
                    <p *ngIf="
                        addrControl.isRequired &&
                        form.get(addrControl.id)?.invalid &&
                        form.get(addrControl.id)?.touched
                      " [id]="addrControl.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
                      {{ addrControl.errorMessage }}
                    </p>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'addressTwo'">
                  <div [class]="addrControl.hiddenClass">
                    <label [for]="addrControl.id" class="label mb-2" *ngIf="addrControl.label"><span
                        [innerHTML]="sanitizeHTML(addrControl.label)"></span></label>
                    <input type="text" [id]="addrControl.id" [placeholder]="addrControl.placeholder ?? ''"
                      class="form-control body-2" [attr.aria-describedby]="addrControl.id + 'HelpBlock'"
                      [attr.maxLength]="addrControl.maxLength!" [name]="addrControl.id"
                      [formControlName]="addrControl.id" [mask]="addrControl.mask!" />
                    <p *ngIf="
                        addrControl.isRequired &&
                        form.get(addrControl.id)?.invalid &&
                        form.get(addrControl.id)?.touched
                      " [id]="addrControl.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
                      {{ addrControl.errorMessage }}
                    </p>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'city'">
                  <div [class]="addrControl.hiddenClass">
                    <label [for]="addrControl.id" class="label mb-2" *ngIf="addrControl.label"><span
                        [innerHTML]="sanitizeHTML(addrControl.label)"></span><span class="text-danger"
                        *ngIf="addrControl.isRequired">*</span></label>
                    <input type="text" [id]="addrControl.id" [placeholder]="addrControl.placeholder ?? ''"
                      class="form-control body-2" [attr.aria-describedby]="addrControl.id + 'HelpBlock'"
                      [attr.maxLength]="addrControl.maxLength!" [name]="addrControl.id"
                      [formControlName]="addrControl.id" [mask]="addrControl.mask!" />
                    <p *ngIf="
                        addrControl.isRequired &&
                        form.get(addrControl.id)?.invalid &&
                        form.get(addrControl.id)?.touched
                      " [id]="addrControl.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
                      {{ addrControl.errorMessage }}
                    </p>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'state'">
                  <div class="row-address middle-control middle-control--hide">
                    <div [ngClass]="[addrControl.hiddenClass, 'state-col']">
                      <!-- State label/input/select -->
                      <label [for]="addrControl.id" class="label mb-2" *ngIf="addrControl.label"><span
                          [innerHTML]="sanitizeHTML(addrControl.label)"></span><span class="text-danger"
                          *ngIf="addrControl.isRequired">*</span></label>
                      <ng-container *ngIf="addrControl.type === 'select'">
                        <div class="form-control form-control__select d-flex flex-wrap overflow-hidden p-0"
                          (click)="handleSelect($event, addrControl.id!)" [ngClass]="{
                            'is-invalid':
                              form.get(addrControl.id!)?.invalid &&
                              form.get(addrControl.id!)?.touched
                          }" [id]="addrControl.id" tabindex="0" aria-haspopup="true" aria-expanded="false"
                          [attr.aria-label]="addrControl.id" role="listbox">
                          <input type="hidden" [id]="addrControl.id" [formControlName]="addrControl.id"
                            [name]="addrControl.id" />
                          <div class="form-control form-control__select__input" [innerHTML]="addrControl.placeholder"
                            [ngClass]="{
                              'is-invalid':
                                form.get(addrControl.id!)?.invalid &&
                                form.get(addrControl.id!)?.touched
                            }"></div>
                          <div
                            class="form-control__select__arrow arrow d-flex align-items-center justify-content-center flex-shrink-0">
                            <div class="form-control__select__arrow__svg">
                              <svg class="img-fluid" width="22" height="18" viewBox="0 0 22 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 18L0.607695 5.02487e-08L21.3923 -1.7668e-06L11 18Z" fill="black" />
                              </svg>
                            </div>
                          </div>
                          <div class="form-control__select__menu w-100" [id]="'options--' + addrControl.id">
                            <ul class="form-control__select__menu__options p-0 m-0">
                              <li class="form-control__select__menu__option" [attr.data-value]="option.value"
                                *ngFor="let option of addrControl.selectOptions" [innerHTML]="option.text"
                                (click)="handleSelect($event, addrControl.id!)" aria-selected="false"
                                [id]="option.value" role="listitem" aria-selected="false"></li>
                            </ul>
                          </div>
                          <p id="alert-message" class="d-none">
                            You are selected
                          </p>
                        </div>
                      </ng-container>
                      <p *ngIf="
                          addrControl.isRequired &&
                          form.get(addrControl.id)?.invalid &&
                          form.get(addrControl.id)?.touched
                        " [id]="addrControl.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
                        {{ addrControl.errorMessage }}
                      </p>
                    </div>
                    <ng-container *ngFor="let zipControl of formControls">
                      <ng-container *ngIf="zipControl.id === 'zipcode'">
                        <div [ngClass]="[zipControl.hiddenClass, 'zipcode-col']">
                          <label [for]="zipControl.id" class="label mb-2" *ngIf="zipControl.label"><span
                              [innerHTML]="sanitizeHTML(zipControl.label)"></span><span class="text-danger"
                              *ngIf="zipControl.isRequired">*</span></label>
                          <input type="text" [id]="zipControl.id" [placeholder]="zipControl.placeholder ?? ''"
                            class="form-control body-2" [attr.aria-describedby]="
                              zipControl.id + 'HelpBlock'
                            " [attr.maxLength]="zipControl.maxLength!" [name]="zipControl.id"
                            [formControlName]="zipControl.id" [mask]="zipControl.mask!" />
                          <p *ngIf="
                              zipControl.isRequired &&
                              form.get(zipControl.id)?.invalid &&
                              form.get(zipControl.id)?.touched
                            " [id]="zipControl.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
                            {{ zipControl.errorMessage }}
                          </p>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <!-- cxheckboxes -->
          <div [class]="control.hiddenClass" *ngIf="
              control.type !== 'radio' &&
              control.id !== 'receiveDirect' &&
              control.id !== 'receiveDirect' &&
              control.id !== 'addressOne' &&
              control.id !== 'addressTwo' &&
              control.id !== 'city' &&
              control.id !== 'state' &&
              control.id !== 'zipcode'
            ">
            <div class="form-check" *ngSwitchCase="'checkbox'">
              <input class="form-check-input mt-0" type="checkbox" [id]="control.id" [name]="control.id"
                [formControlName]="control.id" />
              <label class="form-check-label body-3" [for]="control.id">
                <span [innerHTML]="sanitizeHTML(control.checkboxText)" *ngIf="control.checkboxText"
                  (click)="onCheckboxTextClick($event)"></span>
                <span class="text-danger" *ngIf="control.isRequired && control.id != 'agreeSMS'">*</span>
              </label>
            </div>

            <label [for]="control.id" class="label mb-2" *ngIf="
                (control.label || control.checkboxText) &&
                control.type !== 'checkbox'
              "><span [innerHTML]="sanitizeHTML(control.label)" *ngIf="control.label"></span>
              <span [innerHTML]="sanitizeHTML(control.checkboxText)" *ngIf="control.checkboxText"
                (click)="onCheckboxTextClick($event)"></span>
              <span class="text-danger" *ngIf="control.isRequired">*</span></label>

            <input *ngSwitchCase="'text'" [type]="control.type" [id]="control.id"
              [placeholder]="control.placeholder ?? ''" class="form-control body-2"
              [attr.aria-describedby]="control.id + 'HelpBlock'" [attr.maxLength]="control.maxLength!"
              [name]="control.id" [formControlName]="control.id" [mask]="control.mask!" />
            <span *ngIf="control.id == 'email'" class="email-icon" [ngClass]="{
                'is-invalid':
                  form.get(control.id!)?.invalid &&
                  form.get(control.id!)?.touched
              }"></span>

            <ng-container *ngSwitchCase="'select'">
              <div class="form-control form-control__select d-flex flex-wrap overflow-hidden p-0"
                (click)="handleSelect($event, control.id!)" [ngClass]="{
                  'is-invalid':
                    form.get(control.id!)?.invalid &&
                    form.get(control.id!)?.touched
                }" [id]="control.id" tabindex="0" aria-haspopup="true" aria-expanded="false"
                [attr.aria-label]="control.id" role="listbox">
                <!-- hidden input -->
                <input type="hidden" [id]="control.id" [formControlName]="control.id" [name]="control.id" />
                <!-- input placeholder -->
                <div class="form-control form-control__select__input" [innerHTML]="control.placeholder" [ngClass]="{
                    'is-invalid':
                      form.get(control.id!)?.invalid &&
                      form.get(control.id!)?.touched
                  }"></div>
                <!-- input arrow -->
                <div
                  class="form-control__select__arrow arrow d-flex align-items-center justify-content-center flex-shrink-0">
                  <div class="form-control__select__arrow__svg">
                    <svg class="img-fluid" width="22" height="18" viewBox="0 0 22 18" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 18L0.607695 5.02487e-08L21.3923 -1.7668e-06L11 18Z" fill="black" />
                    </svg>
                  </div>
                </div>
                <div class="form-control__select__menu w-100" [id]="'options--' + control.id">
                  <ul class="form-control__select__menu__options p-0 m-0">
                    <li class="form-control__select__menu__option" [attr.data-value]="option.value"
                      *ngFor="let option of control.selectOptions" [innerHTML]="option.text"
                      (click)="handleSelect($event, control.id!)" aria-selected="false" [id]="option.value"
                      role="listitem" aria-selected="false"></li>
                  </ul>
                </div>
                <p id="alert-message" class="d-none">You are selected</p>
              </div>
            </ng-container>
            @if (control.isRequired && form.get(control.id)?.invalid &&
            form.get(control.id)?.touched) {
            <p [id]="control.id + 'HelpBlock'" class="text-danger mt-2 mb-0">
              {{ control.errorMessage }}
            </p>
            }
          </div>
          <!-- cxheckboxes -->
        </ng-container>
        }
      </div>

      <!-- text bottom -->
      <p class="mb-5">
        You may have certain rights under applicable data privacy laws regarding
        the personal information that you provide, including the right to
        withdraw consent from future collection or sharing of your information.
        For further information regarding these rights, please reference
        <a class="text-decoration-none" href="https://www.sanofi.us/en/consumer-health-data-privacy-policy">Sanofi US
          Privacy Policies and Consumer Health Data Privacy
          Policy.</a>
      </p>

      <!-- submit btn -->
      <button
        class="btn btn-secondary d-flex justify-content-center align-items-center gap-2 text-white fw-bold w-fit mx-auto"
        type="submit">
        <span class="btn__label">Sign up</span>
        <span class="btn__arrow"></span>
      </button>
    </form>
  </div>
</div>